<template lang="pug">
w-menu-item.w-menu-action.action(
  :href='to'
  :class='{ current }'
  @click.prevent='doAction'
)
  template( #default )
    slot( name='icon' )
    slot( name='label' )
      span.text
        slot
</template>

<script lang="js">
import WMenuItem, { mixin } from './w-menu-item'

export default {
  name: 'MenuActionWidget',
  mixins: [ mixin ],
  components: { WMenuItem },
  props: {
    to: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    doAction() {
      if ( this.to ) {
        this.$router.push( this.to )
      } else {
        return this.action()
      }
    }
  },
  computed: {
    current() {
      const { to, $route } = this
      return to && $route &&
         ( to === $route.path // || $route.path.match( `^${ to }/` )
         )
    }
  }
}
</script>

<style lang="scss">
.w-menu-action {
  display: flex;
  align-items: flex-end;
  .icon, .material-design-icon {
    margin-right: var(--s-sm);
  }
  span.text {
    display: block;
    line-height: 1.2em;
  }
}
</style>
